import styled from 'styled-components';
import { themeOptions } from 'styles';

export const StyledAddButton = styled.div`
  .MuiButtonBase-root {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.width ? props.width : null)};
    height: 37px;
    padding: 8px 16px 8px 12px;
    border-radius: 6px;
    border: 1px solid ${themeOptions.palette.green.main};
    box-shadow: none;
  }
  // + 아이콘
  span {
    display: flex;
  }
  .icon {
    align-items: center;
    width: 20px;
    height: 20px;
  }
  // 아이콘 옆 텍스트
  .label {
    padding-left: 5px;
    font-size: 14px;
    font-weight: 500;
    color: ${themeOptions.palette.white.main};
  }

  .MuiButton-text {
    color: ${themeOptions.palette.green.main};
  }

  .MuiButton-contained {
    background: ${themeOptions.palette.green.main} !important;
  }

  .MuiButton-outlined {
    border: 1px solid ${themeOptions.palette.green.main};
    background: ${themeOptions.palette.white.main} !important;
    color: ${themeOptions.palette.green.main};
  }
`;
